import { Component } from "react"
import PropTypes from "prop-types"
import { Button, Typography } from "@mui/material"
import { Link } from "react-router-dom"
import ConfirmIntegrationDialog from "../confirm-integration-dialog"
import ApplicationLogo from "../application-logo"
import { STATUSES } from "modules/platform/constants"

import "./style.scss"

class ApplicationIntegration extends Component {
  static propTypes = {
    application: PropTypes.object.isRequired,
    account: PropTypes.string.isRequired,
    openDialog: PropTypes.func.isRequired,
    closeDialog: PropTypes.func.isRequired,
    termsId: PropTypes.string.isRequired,
    termsText: PropTypes.string.isRequired,
    isSuperuser: PropTypes.bool.isRequired,
    activateApplication: PropTypes.func.isRequired,
  }

  activate = () => {
    const { activateApplication, account, application, termsId, closeDialog } = this.props
    activateApplication(account, application, termsId)
    closeDialog()
  }

  confirm = () => {
    const { openDialog, closeDialog, application, termsText } = this.props

    openDialog({
      title: <div id="application-integration-dialog-header">
        <Typography variant="h6">{application.name} Omega Point Integration Permissions</Typography>
      </div>,
      content: <ConfirmIntegrationDialog closeDialog={closeDialog} confirm={this.activate} termsText={termsText} />,
    })
  }

  CTA = () => {
    const { account, application: { alias, status }, isSuperuser } = this.props
    if (status === STATUSES.ACTIVE) {
      return <Button color="primary" className="confirm"><Link to={`/${account}/applications/${alias}`}>Get started</Link></Button>
    } else {
      return <Button disabled={isSuperuser} color="primary" className="confirm" onClick={this.confirm}>Activate</Button>
    }
  }

  render() {
    const { application: { name, description, logoFilename } } = this.props

    return <div id="partner-integration" className="app-card integration">
      <ApplicationLogo {...{ name, url: logoFilename }} />
      <div className="header">
        <div className="name-wrapper">
          <div className="name">{name}</div>
        </div>
      </div>
      <div className="body">
        <p className="description">{description}</p>
        {this.CTA()}
      </div>
    </div>
  }
}

export default ApplicationIntegration
